import React, { useState } from 'react';

const Header = ({ user, onLogout }) => {
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [logoError, setLogoError] = useState(false);

  // UTF-8 decode fonksiyonu
  const decodeUTF8 = (str) => {
    try {
      if (!str || typeof str !== 'string') return str;
      
      if (str.includes('Ã')) {
        const utfMap = {
          'Ã¶': 'ö', 'Ã¼': 'ü', 'Ã§': 'ç', 'Ä±': 'ı', 'Ä°': 'İ',
          'ÅŸ': 'ş', 'Äž': 'ğ', 'Ã–': 'Ö', 'Ãœ': 'Ü', 'Ã‡': 'Ç',
          'ÅžŸ': 'Ş', 'Äž': 'Ğ'
        };
        
        let decoded = str;
        Object.keys(utfMap).forEach(key => {
          decoded = decoded.replace(new RegExp(key, 'g'), utfMap[key]);
        });
        
        return decoded;
      }
      
      return str;
    } catch (error) {
      console.error('UTF-8 decode hatası:', error);
      return str;
    }
  };

  // Logo handlers
  const handleLogoError = (e) => {
    console.error('Logo yüklenemedi:', e.target.src);
    setLogoError(true);
  };

  const handleLogoLoad = () => {
    console.log('✅ Logo başarıyla yüklendi');
    setLogoError(false);
  };

  // Ad soyad gösterimi
  const getUserDisplayName = () => {
    try {
      if (user.full_name && typeof user.full_name === 'string') {
        const cleanName = decodeUTF8(user.full_name.trim());
        if (cleanName) return cleanName;
      }
      
      if (user.first_name || user.last_name) {
        const firstName = user.first_name ? decodeUTF8(String(user.first_name).trim()) : '';
        const lastName = user.last_name ? decodeUTF8(String(user.last_name).trim()) : '';
        const fullName = `${firstName} ${lastName}`.trim();
        if (fullName) return fullName;
      }
      
      return user.email || 'Kullanıcı';
    } catch (error) {
      console.error('Ad soyad gösteriminde hata:', error);
      return user.email || 'Kullanıcı';
    }
  };

  const safeRenderString = (value) => {
    try {
      if (!value) return '';
      if (typeof value !== 'string') return String(value);
      return decodeUTF8(value.trim());
    } catch (error) {
      console.error('String render hatası:', error);
      return '';
    }
  };

  const safeFormatDate = (dateString) => {
    try {
      if (!dateString) return '';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '';
      return date.toLocaleDateString('tr-TR');
    } catch (error) {
      console.error('Tarih formatı hatası:', error);
      return '';
    }
  };

  return (
    <header className="detsa-header">
      <div className="detsa-header-container">
        
        {/* Sol taraf - Sinarge Logo */}
        <div className="detsa-header-left">
          <div className="detsa-header-logo-container">
            {!logoError ? (
              <img 
                src="/detsa/images/beyazarkayok.png" 
                alt="Sinarge Logo" 
                className="detsa-header-logo"
                onError={handleLogoError}
                onLoad={handleLogoLoad}
                style={{
                  width: 188,
                  height: 98,
                  marginBottom: 8,
                  display: 'block',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }}
              />
            ) : (
              <div className="detsa-header-logo-fallback">
                <span style={{ fontSize: '16px', color: '#dc2626', fontWeight: 'bold' }}>
                  SİNARGE
                </span>
              </div>
            )}
          </div>
        </div>

        {/* Orta - Başlık + ICO */}
        <div className="detsa-header-center">
          <div className="detsa-header-title-container">
            {/* ICO Icon - Başlığın üstünde */}
            
            
            {/* Başlık - ICO'nun altında */}
            <h1 className="detsa-header-title">
              Detsa IT Sistemi
            </h1>
          </div>
        </div>

        {/* Sağ taraf - User Info + Version */}
        <div className="detsa-header-right">
          {user && (
            <div className="detsa-header-user-section">
              {/* User Info */}
              <div className="detsa-header-user-info">
                <div className="detsa-header-user-dropdown-container">
                  <span 
                    className="detsa-header-user-email-btn"
                    onClick={() => setShowUserDropdown(!showUserDropdown)}
                  >
                    {getUserDisplayName()} ({user.role === 'admin' ? 'Yönetici' : user.role === 'ik' ? 'İK' : 'Kullanıcı'})
                    <span className="detsa-header-dropdown-arrow">▼</span>
                  </span>
                  
                  {showUserDropdown && (
                    <div className="detsa-header-user-dropdown">
                      <div className="detsa-header-user-dropdown-header">
                        <h4>👤 Kullanıcı Bilgileri</h4>
                      </div>
                      
                      <div className="detsa-header-user-dropdown-content">
                        <div className="detsa-header-user-detail">
                          <span className="detsa-header-detail-label">Email:</span>
                          <span className="detsa-header-detail-value">{user.email}</span>
                        </div>
                        
                        {user.full_name && (
                          <div className="detsa-header-user-detail">
                            <span className="detsa-header-detail-label">Ad Soyad:</span>
                            <span className="detsa-header-detail-value">{safeRenderString(user.full_name)}</span>
                          </div>
                        )}
                        
                        {!user.full_name && (user.first_name || user.last_name) && (
                          <div className="detsa-header-user-detail">
                            <span className="detsa-header-detail-label">Ad Soyad:</span>
                            <span className="detsa-header-detail-value">
                              {`${safeRenderString(user.first_name)} ${safeRenderString(user.last_name)}`.trim()}
                            </span>
                          </div>
                        )}
                        
                        <div className="detsa-header-user-detail">
                          <span className="detsa-header-detail-label">Rol:</span>
                          <span className="detsa-header-detail-value">
                            {user.role === 'admin' ? 'Yönetici' : user.role === 'ik' ? 'İK' : 'Kullanıcı'}
                          </span>
                        </div>
                        
                        {(user.phone || user.phone_number) && (
                          <div className="detsa-header-user-detail">
                            <span className="detsa-header-detail-label">Telefon:</span>
                            <span className="detsa-header-detail-value">
                              0{safeRenderString(user.phone || user.phone_number)}
                            </span>
                          </div>
                        )}
                        
                        {user.gender && (
                          <div className="detsa-header-user-detail">
                            <span className="detsa-header-detail-label">Cinsiyet:</span>
                            <span className="detsa-header-detail-value">
                              {user.gender === 'male' ? '♂️ Erkek' : 
                               user.gender === 'female' ? '♀️ Kadın' : 
                               '❓ Belirtilmemiş'}
                            </span>
                          </div>
                        )}
                        
                        {user.hire_date && (
                          <div className="detsa-header-user-detail">
                            <span className="detsa-header-detail-label">📅 İşe Giriş:</span>
                            <span className="detsa-header-detail-value">
                              {safeFormatDate(user.hire_date)}
                            </span>
                          </div>
                        )}
                      </div>
                      
                      <div className="detsa-header-user-dropdown-footer">
                        <button 
                          onClick={onLogout} 
                          className="detsa-header-logout-btn-dropdown"
                        >
                          🚪 Çıkış Yap
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                
                <button onClick={onLogout} className="detsa-header-logout-btn">Çıkış</button>
              </div>
              
              {/* Version Info - YENİ */}
              <div className="detsa-header-version">
                <span className="detsa-header-version-text">v2.0.0</span>
              </div>
            </div>
          )}
        </div>
        
        {showUserDropdown && (
          <div 
            className="detsa-header-dropdown-overlay"
            onClick={() => setShowUserDropdown(false)}
          />
        )}
      </div>
    </header>
  );
};

export default Header;